import React from 'react';
import { SectionComponent } from './SectionComponent';
import { IPageSectionEntry } from '../../../contentful';

interface IProps {
	sections?: IPageSectionEntry[];
}
export function PageSections({ sections }: IProps) {
	if (!Array.isArray(sections)) {
		return null;
	}

	return (
		<>
			{sections.map((section: IPageSectionEntry) => (
				<SectionComponent key={section.id} section={section} />
			))}
		</>
	);
}
